
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.727 9.582L2.82 16.477c-1.05.813-2.694.152-2.694-1.083V1.606c0-.277.09-.547.259-.78.169-.232.41-.416.694-.53.285-.115.6-.154.91-.114.309.04.598.16.833.341l8.905 6.895c.174.134.314.3.41.488a1.3 1.3 0 01.146.594 1.3 1.3 0 01-.146.594 1.467 1.467 0 01-.41.488h.001z","fill":"#2034E9"}})])
          )
        }
      }
    